module.exports = __webpack_public_path__ + "media/reskin-images/icon--minus-63b7f698.svg";